import styled from 'styled-components'
import theme from '../../global/theme'

export const HomeContainer = styled.main`
  background-color: ${theme.Colors.background};
`
